<template>
  <Modal
    v-model="_value"
    width="800"
    title="设置角色"
    @on-visible-change="visibleChange"
    ok-text="修改"
    @on-ok="onOk">
    <Row>
      <div>
        <label>当前用户ID：{{userInfo.id}} 用户名：{{userInfo.name}} 手机号码：{{userInfo.mobilePhoneNum}}</label>
      </div>
    </Row>
    <Row style="margin-top: 10px;">
      <Transfer
        :titles="titles"
        :data="allRoles"
        :target-keys="ownRoles"
        :list-style="listStyle"
        :render-format="transferRender"
        @on-change="onChange"></Transfer>
    </Row>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'SetRoleModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        titles:['系统角色', '拥有角色'],
        ownRoles:[],
        allRoles:[],
        listStyle:{
          width: '350px'
        },
        userId: null,
        userInfo: {
          id:null,
          name:'',
          nickName:'',
          mobilePhoneNum:'',
          roles:[]
        }
      }
    },
    methods: {
      ...mapActions([
        'UserServ_SetRoles',
        'RoleServ_GetAll',
        'UserServ_GetDetail'
      ]),
      onChange(newTargetKeys, direction, moveKeys){
        this.ownRoles = newTargetKeys;
      },
      transferRender(item){
        return item.nickName===null?item.name:item.nickName
      },
      onOk() {
        let roles = [];
        roles = this.ownRoles.map(item => {return parseInt(item)})
        store.dispatch('UserServ_SetRoles', {params: {userId: this.userId, roleIds: roles}}).then(() => {
          this.$Message.success("设置成功");
        }).catch(err => {
          this.$Message.error(err);
        });
      },
      visibleChange(val) {
        if (val) {
          let userId = this._initValue
          if (userId) {
            this.userId = userId
            store.dispatch('RoleServ_GetAll', {params: null, urlparams: null}).then(() => {
              store.dispatch('UserServ_GetDetail', {
                params: {id: userId}
              }).then(() => {
                this.userInfo = store.getters.get_User_GetDetailResult
                this.allRoles = []
                this.ownRoles = []
                this.userInfo.roles.forEach((item, index) => {
                  this.ownRoles.push(item.id.toString())
                })
                store.getters.get_Role_GetAllResult.forEach((item, index) => {
                  Vue.set(item, 'key', item.id.toString())
                  this.allRoles.push(item)
                })
              }).catch(err => {
                this.$Message.error(err)
              })
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
